import { useMemo } from 'react';
import { qrSvgPath } from '../../shared/qr';

/** A QR code drawn as crisp squares (prints sharp on thermal paper). */
export function QrCode({ text, size = 120, label }: { text: string; size?: number; label?: string }) {
  const q = useMemo(() => qrSvgPath(text), [text]);
  return (
    <svg className="qr" width={size} height={size} viewBox={`0 0 ${q.size} ${q.size}`} shapeRendering="crispEdges" role="img" aria-label={label ?? `QR code ${text}`}>
      <rect width={q.size} height={q.size} fill="#fff" />
      <path d={q.path} fill="#000" />
    </svg>
  );
}
